module.exports = "https://trybtryb-legacy.web.app/img/blue-frost.f4379a10.webp";